import { DynamicStandaloneMarkup } from '@/components/Markup';
import { LabradorComponent } from '@/types/component';
import { widthToClass } from '@/utils/index';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorMarkup: LabradorComponent = ({ type, meta, data }) => {
  const widthClass = widthToClass(meta.width);

  return (
    <DynamicStandaloneMarkup
      markup={data.markup}
      options={{ className: widthClass }}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorMarkup;
